import React from 'react';
import css from './AnimatedPlaceholderChatroomEntry.scss';
import classnames from 'classnames';
var AnimatedPlaceholderChatroomEntry = function () {
    return (React.createElement("div", { className: classnames(css.entryV2, css.animatedBackground) },
        React.createElement("div", { className: classnames(css.circleWrapper) }),
        React.createElement("div", { className: classnames(css.whiteBlock, css.upperBlockWhiteSpace) }),
        React.createElement("div", { className: classnames(css.whiteBlock, css.firstBlockWhiteSpace) }),
        React.createElement("div", { className: classnames(css.whiteBlock, css.betweenBlocksWhiteSpace) }),
        React.createElement("div", { className: classnames(css.whiteBlock, css.bottomBlockWhiteSpace) }),
        React.createElement("div", { className: classnames(css.whiteBlock, css.verticalBlockWhiteSpace) })));
};
export default AnimatedPlaceholderChatroomEntry;
//# sourceMappingURL=AnimatedPlaceholderChatroomEntry.js.map